export default __webpack_public_path__ + "static/media/refreshing.5ad64434.svg";